var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8041c9642bd945ab788558741e2b942335a0aeb9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["policy-expert-site@qmetric"]={id:"8041c9642bd945ab788558741e2b942335a0aeb9"};
      